import * as ng from 'angular';
import { PanelHeaderData } from '../../../atomic-components/molecules/panels/panel-header/panel-header';
import { PaymentOverviewModel } from '../../../services/billing/payment-overview-model';

export class TemplatePaymentOverviewController {
    public static $inject: string[] = ['$translate'];

    public rightPanelArea = [];
    public modifier = '';
    public pageHeaderData: PanelHeaderData;
    public overviewServiceData: any;
    public expertView: boolean;
    public overviewModel: PaymentOverviewModel;

    private simpleFilter;
    private overviewUiSettings;

    constructor(private $translate: ng.translate.ITranslateService) {}

    public $onInit() {
        if ([undefined, null].indexOf(this.simpleFilter) === -1) {
            this.expertView = this.overviewUiSettings.expertView || this.simpleFilter.show;
        } else {
            this.expertView = this.overviewUiSettings.expertView || false;
        }

        this.pageHeaderData = {
            backwardLink: 'billing.dashboard',
            backwardText: this.$translate.instant('TR_090119-ebc8d5_TR'),
            panelHeaderRoute: '',
            panelHeaderRouteParams: null,
            panelIcon: 'history',
            panelTitle: this.$translate.instant('TR_040619-4ca9a1_TR')
        };
        this.overviewServiceData = {
            fancyFilterExpand: this.expertView,
            overviewUiSettings: this.overviewUiSettings,
            simpleFilter: this.simpleFilter
        };
    }

    public expandWrapper = (toggle: any) => {
        this.expertView = toggle.expand;
    };
}

export class TemplatePaymentOverviewComponent implements ng.IComponentOptions {
    public bindings = {
        overviewModel: '<',
        overviewUiSettings: '<',
        simpleFilter: '<'
    };
    public controller = TemplatePaymentOverviewController;
    public controllerAs = 'TemplatePaymentOverviewCtrl';
    public template = require('./payment-overview-template.html');
}
